<template>
  <div class="orderitem">
    <div class="orderitem-line2" v-for="item in ordergoods" :key="item.id">
        <div class="orderitem-line2-col1"><img :src='item.headimg' class="goodsimg" /></div>
        <div class="orderitem-line2-col2">
              <div class="goodstitle">{{item.name}}</div>
              <div class="goodsparent">{{item.sellername}}</div>
              <div class="pricerow">
                   <div class="price">售价{{item.price}}</div>
                   <div class="nums">X{{item.nums}}</div>
              </div>
        </div>
    </div>
    <div class="orderitem-address">
      <div class="orderitem-address-col1">收件人信息:</div>
      <div class="orderitem-address-col2">
             <div class="recname">{{orderinfo.name}} {{orderinfo.mobile}}</div>
             <div class="addrinfo">{{orderinfo.province+orderinfo.city+orderinfo.county+orderinfo.address}}</div>
      </div>
    </div>
    <div class="orderitem-orderinfo">
      <div class="orderitem-orderinfo-line1">订单号:{{orderinfo.ordernum}}</div>
      <div class="orderitem-orderinfo-line2">
           <div class="orderitem-orderinfo-line2-col1">产生订单时间:{{orderinfo.date}}</div>
           <div class="orderitem-orderinfo-line2-col2">订货人:{{orderinfo.buyername}}</div>
      </div>
    </div>

    <div class="orderitem-btncon" v-if="orderinfo.status==1">
         <div class="badge-grey">待支付</div>
         <div class="offlinecon">
            <div class="orderitem-btn" @click="doOfflinePay(orderinfo.id)">线下确认</div>
          </div>
    </div>
    <div class="orderitem-btncon" v-else-if="orderinfo.status==2">
      <div class="badge-grey">待发货</div><div class="orderitem-btn" @click="goFahuo(orderinfo.id)">去发货</div>
    </div>
    <div class="orderitem-btncon" v-else-if="orderinfo.status==3||orderinfo.status==4">
      <div class="badge-grey">已发货</div><div class="loginfo">{{orderinfo.expresscorp}}:{{orderinfo.expressnums}}</div>
   </div>  
   </div>
</template>
<script>
export default {
  name: 'FahuoItem',
  props: {
    orderinfo:Object,
    ordergoods:Array
  },
  data(){
    return{
       processing:false
    }
  },
  methods: {
    goFahuo(orderid){
       this.$go("/surefahuo/"+orderid)
    },
    doOfflinePay(orderid){
       if(this.processing){
        this.$toast("请等待交易完成");return false;
       }
       this.processing=true
       this.$post("/fahuo/doOfflinePay",{orderid:orderid}).then((data)=>{
           this.processing=false
           if(data.result.success){
               this.$toast(data.result.info)
               this.$go("/index")
           }else{
               this.$toast(data.result.info)
           }
       })
    }
  },
}
</script>
<style scoped>
.orderitem{display: flex;flex-flow: column nowrap;background-color: #fff;margin-bottom: 0.25rem;border-radius: 0.1rem;margin-top: 0.25rem;}
.orderitem-line1{display: flex;align-items: center;padding: 0.3rem;border-bottom: 1px solid #e7e7e7;}
.badge-red{font-size:0.3rem;border-radius: 0.1rem;border:1px solid #ff3600;color:#ff3600;padding: 0.05rem;}
.orderitem-line1-col2{font-size:0.33rem;padding: 0.1rem;padding-left: 0.3rem;}
.orderitem-line1-col3{margin-left: auto;}
.badge-grey{border:1px solid #999999;color:#999999;font-size: 0.3rem;padding: 0.1rem;border-radius: 0.1rem;align-items: center;height: 0.7rem;display: flex;}
.orderitem-line2{display: flex;border-bottom: 1px solid #e7e7e7;align-items: center;padding: 0.3rem;}
.goodsimg{width:2rem;height:2rem;}
.orderitem-line2-col2{display: flex;flex-flow: column nowrap;padding-left: 0.3rem;align-self: flex-start;width:100%;}
.goodstitle{font-size:0.33rem;color:#3c3c3c;text-align: left;}
.goodsparent{font-size:0.33rem;color:#ff3600;text-align: left;padding: 0.15rem 0;}
.pricerow{display: flex;margin-top: 0.1rem;}
.price{color:#5e5e5e;font-size:0.33rem;}
.nums{margin-left: auto;font-size:0.33rem;color:#5e5e5e}
.orderitem-line3{display: flex;padding: 0.3rem;}
.orderitem-line3-col2{margin-left: auto;}
.price-red{color:#ff3600;font-size:0.33rem}
.orderitem-address{display: flex;flex-flow: row nowrap;border-bottom: 1px solid #e7e7e7;}
.orderitem-address-col1{padding: 0.3rem;text-align: left;width:3rem;}
.orderitem-address-col2{display: flex;flex-flow: column nowrap;padding: 0.3rem;}
.orderitem-orderinfo{display: flex;flex-flow: column nowrap;padding: 0.3rem;border-bottom: 1px solid #e7e7e7;}
.orderitem-orderinfo-line2{display: flex;}
.orderitem-orderinfo-line1{text-align: left;font-size:0.33rem;margin-bottom: 0.2rem;}
.orderitem-orderinfo-line2-col1{font-size:0.33rem;}
.orderitem-orderinfo-line2-col2{margin-left: auto;font-size:0.33rem;}
.recname,.addrinfo{text-align: left;font-size:0.33rem}
.orderitem-btncon{padding: 0.3rem;display: flex;align-items: center;}
.orderitem-btn{background-color:#ee0a24;color:#fff;height:0.85rem;font-size:0.33rem;width:2rem;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;margin-left:auto;}
.loginfo{margin-left: auto;padding: 0.1rem;font-size:0.33rem}
.offlinecon{display: flex;flex-flow: row nowrap;margin-left: auto;align-items: center;}
.getyzm{display: flex;align-items: center;justify-content: center;font-size:0.3rem;color:#333;text-decoration:underline;}
.offlineinput{background-color: #f8f8f8;color:#000;font-size:0.32rem;height:0.85rem;width:2.0rem;padding: 0.1rem;text-align: center;}
</style>


